import React from 'react';
import PropTypes from 'prop-types';
import { gettext } from '@eventbrite/i18n';
import classNames from 'classnames';

import ModalMessage from '../ModalMessage';

const ForgotPasswordEmailStatus = ({ email, usesNewStyles }) => {
    const headerText = gettext('Check your email to update your password');
    const componentClasses = classNames('eds-l-mar-vert-14', {
        'reset-password-status-page': usesNewStyles,
    });
    const subtitleText = (
        <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
                __html: gettext(
                    'We sent a link to <strong>%(email)s</strong> to update your password.',
                    {
                        email,
                    },
                ).toString(),
            }}
        />
    );

    return (
        <div className={componentClasses}>
            <ModalMessage headerText={headerText} subtitleText={subtitleText} />
        </div>
    );
};

ForgotPasswordEmailStatus.propTypes = {
    email: PropTypes.string,
    usesNewStyles: PropTypes.bool,
};

export default ForgotPasswordEmailStatus;
